import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faUser,
  faCoffee,
  faSearch,
  faPortrait,
} from "@fortawesome/free-solid-svg-icons";

library.add(fab, faUser, faCoffee, faSearch, faPortrait);
